module.exports = __webpack_public_path__ + "img/pic-meet.2b09b809.jpg";